import flex from '../../styles/flex';
import fonts from '../../styles/fonts';
import palette from '../../styles/palette';
import position from '../../styles/position';

const styles = {
    bg: {
        ...position.absoluteFill,
        overflow: "hidden",
        transition: "all 0.2s ease-in-out 0s",
        backgroundColor: "white",

    },
    logo: {
        maxWidth: 200
    } as React.CSSProperties,
    centeredBox: {
        ...flex.flexColumns,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
    } as React.CSSProperties,
    centeredBoxInner: {
        padding: 50
    } as React.CSSProperties,
    title: {
        ...fonts.title,
        color: palette.text.primary,
    } as React.CSSProperties,
    message: {
        ...fonts.subTitle,
        color: palette.text.secondary,
    } as React.CSSProperties,
    topCenteredBox: {
        ...flex.flexColumns,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
    } as React.CSSProperties,
};

export default styles;